import { WidgetBase, SortType } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetMeasuresByCategoryComponent } from "../Components/WidgetMeasuresByCategoryComponent";
import { PopupMeasuresByCategoryComponent } from "../Popups/PopupMeasuresByCategoryComponent";
import { app } from "../../../Frame/App";

export class WidgetMeasuresByCategoryColumnFilter {
    categoryContentId: number;
    filter: string;
}

export class WidgetMeasuresByCategoryProps {
    public markupHeader: string;
    public markupItems: string;
    public styles: string;
    public clientId: string;
    public rowClickLayoutId: number;
    public categoryId: number;
    public templateId: string;
    public additionalFilter: string;
    public columnFilters: WidgetMeasuresByCategoryColumnFilter[] = [];
    public loadImages: boolean;
    public sortFirst: string;
    public sortFirstAsc: SortType;
    public sortSecond: string;
    public sortSecondAsc: SortType;
}

export class WidgetMeasuresByCategory extends WidgetBase {
    props: WidgetMeasuresByCategoryProps;
    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetMeasuresByCategoryProps();
        this.props.sortFirstAsc = SortType.desc;
        this.props.sortSecondAsc = SortType.desc;
        //this.props.columnFilters = [];
    }

    getType(): WidgetTypes {
        return WidgetTypes.MeasuresByCategory;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (app.isNullOrUndefined(this.props.sortFirstAsc))
                this.props.sortFirstAsc = SortType.desc;
            if (app.isNullOrUndefined(this.props.sortSecondAsc))
                this.props.sortSecondAsc = SortType.desc;
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    showPopup(): void {
        let popup = new PopupMeasuresByCategoryComponent({ widget: this });
        document.body.appendChild(popup.render());
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetMeasuresByCategoryComponent({
            widget: this,
            markupHeader: this.props.markupHeader,
            markupItems: this.props.markupItems,
            styles: this.props.styles,
            clientId: this.props.clientId,
            rowClickLayoutId: this.props.rowClickLayoutId,
            categoryId: this.props.categoryId,
            templateId: this.props.templateId,
            additionalFilter: this.props.additionalFilter,
            columnFilters: this.props.columnFilters,
            loadImages: this.props.loadImages,
            sortFirst: this.props.sortFirst,
            sortFirstAsc: this.props.sortFirstAsc,
            sortSecond: this.props.sortSecond,
            sortSecondAsc: this.props.sortSecondAsc
        });
        return this.component.render();
    }

}